/**
 * Color Mapping Constants
 * Extracted from TeamGanttImporter.tsx
 * Maps TeamGantt color names to hex color codes
 */

export const COLOR_MAP: Record<string, string> = {
  'blue3': '#3b82f6',
  'brown1': '#d97706',
  'yellow1': '#f59e0b',
  'green1': '#10b981',
  'red1': '#ef4444',
  'purple1': '#8b5cf6',
  'pink1': '#ec4899',
  'gray1': '#6b7280'
};
